var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { Children } from "react";
import classNames from "classnames";
import { Button } from "../Button";
// styles
import "./buttonGroup.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-buttonGroup",
    orientation: "horizontal",
    fluid: false,
    outlined: false,
    size: "medium",
    link: false,
    rounded: false,
    color: "primary",
    segmented: false,
};
const ButtonGroup = (_a) => {
    var { className, children, orientation, fluid, segmented } = _a, rest = __rest(_a, ["className", "children", "orientation", "fluid", "segmented"]);
    const classList = classNames("tecma-buttonGroup", { [`${orientation}`]: orientation }, { fluid }, { segmented }, className);
    return (_jsx("div", Object.assign({ className: classList }, rest, { children: Children.map(children, (child) => {
            if (child.type === Button) {
                return React.cloneElement(child, Object.assign({ fluid }, rest));
            }
            return console.warn("wrong type of component");
        }) })));
};
ButtonGroup.defaultProps = defaultProps;
export default React.memo(ButtonGroup);
